import ItemCollection from './ItemCollection';

export default ItemCollection;
